import { render, staticRenderFns } from "./CreatedFormConfig.vue?vue&type=template&id=8843afe0"
import script from "./CreatedFormConfig.vue?vue&type=script&lang=js"
export * from "./CreatedFormConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8843afe0')) {
      api.createRecord('8843afe0', component.options)
    } else {
      api.reload('8843afe0', component.options)
    }
    module.hot.accept("./CreatedFormConfig.vue?vue&type=template&id=8843afe0", function () {
      api.rerender('8843afe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Formcreated/components/CreatedFormConfig.vue"
export default component.exports